import type { ScheduledMeeting } from '../../../contexts';

/**
 * Sorts meetings alphabetically by description.
 */
export const sortPersonalMeetings = (meetings: ScheduledMeeting[]): ScheduledMeeting[] =>
  [...meetings].sort((a, b) => (a.description ?? '').localeCompare(b.description ?? ''));
